module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Mobile@1x.1c50940c.jpg";